/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2023. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createAction, props } from '@ngrx/store';
import { ContactInfo } from '@truckstop-tms/zuum-lib';

export const loadContactInfo = createAction('[ClientDetails] Load Contact Info', props<{ clientId: number }>());
export const loadContactInfoSuccess = createAction(
  '[ClientDetails] Load Contact Info Success',
  props<{ contactInfo: ContactInfo[] }>()
);

export const updateContactInfo = createAction(
  '[ClientDetails] Update Contact Info',
  props<{ contactInfo: Partial<ContactInfo> }>()
);
export const updateContactInfoSuccess = createAction(
  '[ClientDetails] Update Contact Info Success',
  props<{ contactInfo: ContactInfo }>()
);

export const updateAccountingContactInfo = createAction(
  '[ClientDetails] Update Accounting Contact Info',
  props<{ accountingContactInfo: Partial<ContactInfo> }>()
);
export const updateAccountingContactInfoSuccess = createAction(
  '[ClientDetails] Update Accounting Contact Info Success',
  props<{ accountingContactInfo: ContactInfo }>()
);

export const updateAccountingPayableContactInfo = createAction(
  '[ClientDetails] Update Accounting Payable Contact Info',
  props<{ accountingPayableContactInfo: Partial<ContactInfo> }>()
);
export const updateAccountingPayableContactInfoSuccess = createAction(
  '[ClientDetails] Update Accounting Payable Contact Info Success',
  props<{ accountingPayableContactInfo: ContactInfo }>()
);

export const setCompanyLogo = createAction(
  '[ClientDetails:Company Profile] Set Company Logo',
  props<{ companyLogo: string }>()
);
export const uploadCompanyLogo = createAction(
  '[ClientDetails:Company Profile] Upload Company Logo',
  props<{ companyLogo: string }>()
);

export const failure = createAction('[ClientDetails: CompanyProfile] Failure', props<{ errorMessage: string }>());
